export const mapKeyDiff = <K, >(
    a: ReadonlyMap<K, unknown>,
    b: ReadonlyMap<K, unknown>,
): { missingFromA: K[]; missingFromB: K[] } => {
    const missingFromA: K[] = [];
    const missingFromB: K[] = [];

    const aKeys = Array.from(a.keys());
    const bKeys = Array.from(b.keys());
    // eslint-disable-next-line no-restricted-syntax
    for (const k of bKeys) if (!a.has(k)) missingFromA.push(k);
    // eslint-disable-next-line no-restricted-syntax
    for (const k of aKeys) if (!b.has(k)) missingFromB.push(k);

    return { missingFromA, missingFromB };
};

export default mapKeyDiff;
